// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"238":"76cc947b","397":"47a13c96","858":"159414fd","896":"51a51928"}[chunkId] + ".css";
};